import { IRootStore } from '@src/models';
import { ROUTES } from 'src/constants';

type HandlerArgs = {
  action: {
    tree: IRootStore;
  };
};

const profileFlows = {
  [ROUTES.candidatesRoutes.profile.edit.base]: {
    exact: false,
    call: ({ action }: HandlerArgs) => {
      // user's info could be changed after job application so we need to refresh it
      if (action.tree.authStore.isAuthorized) {
        action.tree.userStore.fetchUser();
      }
      action.tree.resourcesStore.fetchAllThemes({ on_moderation: false });
    }
  },
  [ROUTES.candidatesRoutes.profile.edit.general]: {
    call: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.getCountries();
      action.tree.resourcesStore.getLanguages();
      action.tree.resourcesStore.getLanguagesLevels();
    }
  },
  [ROUTES.candidatesRoutes.profile.edit.employment]: {
    call: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.getIndustries();
      action.tree.resourcesStore.getJobFunctions();
    }
  },
  [ROUTES.candidatesRoutes.profile.edit.education]: {
    call: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.getDegrees();
      action.tree.resourcesStore.getMajors();
    }
  },
  [ROUTES.candidatesRoutes.preferences.roles]: {
    call: ({ action }: HandlerArgs) => {
      action.tree.userStore.getFavoriteRoles();
    },
    abort: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.abort();
      action.tree.userStore.abort();
    }
  },
  [ROUTES.candidatesRoutes.preferences.workPlaces]: {
    call: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.getWorkPlaces();
      action.tree.userStore.getUserWorkplaces();
      action.tree.userStore.getUserVisas();
    },
    abort: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.abort();
      action.tree.userStore.abort();
    }
  }
};

export default profileFlows;
